import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    }
    .button {
    background-color: transparent;
    border: none;
    color: white;
    font-size: 50px;
    cursor: pointer;
    font-family: 'Lucida Console', cursive;
    margin-bottom: 600px;
    }
`;

export class MinimapComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();

    public constructor() {
        super();
    }

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        const displayImage: HTMLElement = html`
        <div>
            <img src="/assets/img/rooms/Minimap.png">
            <div class="container">
            <style>
                ${styles}
            </style>
            <button class="button">EXIT</button>
            </div>
        </div>
`;
        displayImage.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.Canvas);
        });
        const image: HTMLImageElement = document.createElement("img");
        image.src = "/assets/img/rooms/Minimap.png";
        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(displayImage);
    }
}
